import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { AlertService } from '../alert.service';
import { NGXLogger } from 'ngx-logger';
import { ReviewOrderComponent } from '../reviews/review-order/review-order.component';
import { IOrderReview } from '@redirector-service/shared';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'tea-shop-fe-review-writer',
  standalone: true,
  imports: [
    ReviewOrderComponent,
    DatePipe,
],
  templateUrl: './review-writer.component.html',
  styleUrl: './review-writer.component.css'
})
export class ReviewWriterComponent implements OnInit {
  private alertService = inject(AlertService);
  private logger = inject(NGXLogger);


  @Input() orderId?: string;
  @Input() orderReview?: IOrderReview;
  @Output() reviewSubmitted = new EventEmitter<{rating: number, comment?: string}>();

  ngOnInit(): void {
    if (this.orderReview) {
      this.logger.debug('Order Review:', this.orderReview);
      // this.alertService.show({ title: 'Order Review found', description: JSON.stringify(this.orderReview) , type: 'info'});
      // alert('review writer: ' + JSON.stringify(this.orderReview));
    } else {
      this.logger.debug('No Order Review found');
      // this.alertService.show({ title: 'No Order Review found', type: 'error'});
    }
  }

  onReviewSubmitted(reviewData: {rating: number, comment?: string}): void {
    this.logger.debug('Review submitted:', reviewData);
    this.reviewSubmitted.emit(reviewData);
  }
}
